import Vue from "vue";

import "normalize.css/normalize.css";
import "@/icons"; // icon
import "@/permission"; // permission control

import { format } from "date-fns";
import { ru } from "date-fns/locale";

//element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/element-ui/style/theme/index.css";
import locale from "element-ui/lib/locale/lang/ru-RU";
Vue.use(ElementUI, { locale });

import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixin from "./mixins/device";

Vue.config.productionTip = false;
const userTimezone = new Date().getTimezoneOffset() * 60 * 1000;

Vue.filter("formatDate", (date) => {
  return date ? format(new Date(date), "d MMMM yyyy", { locale: ru }) : "";
});

Vue.filter("formatDateTime", (datetime) => {
  return datetime
    ? format(Date.parse(datetime) + userTimezone, "d MMMM yyyy HH:mm", {
        locale: ru,
      })
    : "";
});

new Vue({
  el: "#app",
  router,
  store,
  mixin,
  render: (h) => h(App),
});
